export default __webpack_public_path__ + "static/media/Cinestream.5cb5f0e2.png";